import { render, staticRenderFns } from "./Block-Table.vue?vue&type=template&id=bb29f196&scoped=true&"
import script from "./Block-Table.vue?vue&type=script&lang=js&"
export * from "./Block-Table.vue?vue&type=script&lang=js&"
import style0 from "./Block-Table.vue?vue&type=style&index=0&id=bb29f196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb29f196",
  null
  
)

export default component.exports